import Gator from 'gator';
import { getParents, nodeArray } from '../../General';

const VIDEO_CLASS = 'jonnitto-prettyembed';
const ELEMENT_CLASS = 'full-video';

Gator(document).on('click', `.-live .${ELEMENT_CLASS}__button`, function () {
    const parent = getParents(this, `.${ELEMENT_CLASS}`)[0];
    const video = parent.querySelector(`.${VIDEO_CLASS}`);
    if (video.classList.contains(`${VIDEO_CLASS}--inline`)) {
        parent.classList.add(`${ELEMENT_CLASS}--play`);
    }
    video.click();
});
